import React, { useEffect, useState } from "react";

const NavbarButtonBar = () => {
  const [state, setState] = useState(false);

  const toggleMenu = (e) => {
    e.preventDefault();

    setState(!state);
  };

  useEffect(() => {
    var element = document.getElementById("tag-body");

    if (state) {
      element.classList.add("mini-navbar");
    } else {
      element.classList.remove("mini-navbar");
    }
  }, [state]);

  return (
    <>
      <a
        className="navbar-minimalize minimalize-styl-2 btn btn-success"
        href="#!"
        onClick={(e) => toggleMenu(e)}
      >
        <i className="fa fa-bars"></i>{" "}
      </a>
    </>
  );
};

export default NavbarButtonBar;
